import React, { Component } from "react";
import { MDBIcon } from "mdb-react-ui-kit";
import "./ActorDetail.css";

import ModalPortal from "../../Projects/AdminProjectDetail/modals/ModalPortal";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { toast } from "Projects/CC_cubi_clan_project/GlobalComponents/ToastHost/ToastHost";
import { mfmFramedUrl } from "Projects/CC_cubi_clan_project/Utils/MfmService";
import { MfmPhoto } from "Projects/CC_cubi_clan_project/GlobalComponents/MfmPhoto/MfmPhoto";

import profile_default_img from "images/profile_default.png";

const PORTRAIT_FORMAT_KEY = "ratio:3:4";
const LANDSCAPE_FORMAT_KEY = "ratio:16:9";

/**
 * ActorDetail
 *
 * Ficha pública completa de un actor: cabecera con foto carnet + datos,
 * biografía (HTML rico), roles destacados con detalle en modal,
 * y obras en las que participa con enlace a nueva pestaña.
 */
class ActorDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actorId: null,
      actor: {},
      highlightRoles: [],
      publishedProjects: [],
      loading: true,
      selectedRole: null,
      showRoleModal: false,
    };
  }

  componentDidMount() {
    this.initSelectedActor();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.actorId !== prevState.actorId) {
      this.loadActor(this.state.actorId);
    }
  }

  initSelectedActor() {
    const propSlug = this.props.actorSlug;
    if (propSlug) {
      this.setState({ actorId: propSlug, loading: true });
    } else {
      const location = "" + window.location;
      const match = location.match(/actor\/([^/]+)$/);
      if (match) {
        this.setState({ actorId: match[1], loading: true });
      } else {
        this.setState({ loading: false });
      }
    }
  }

  loadActor = (id) => {
    if (!id) return;
    this.setState({ loading: true });
    doFetch("MUGIN", `getActor?slug=${id}`, { method: "GET" })
      .then((r) => r.json())
      .then((data) => {
        const actor = data?.DATA || {};
        const rolesByProject = {};
        const highlightRoles = [];
        const publishedProjects = [];

        for (const rol of actor.roles || []) {
          const personaje = rol.personaje;
          const proyecto = personaje?.proyecto;
          if (!proyecto) continue;
          // rol.status controla visibilidad en ficha pública del actor (gestionado desde admin).
          // personaje.status y proyecto.status deben estar publicados para mostrarse.
          if (rol.status !== "published" || personaje?.status !== "published" || proyecto.status !== "published") continue;

          if (!rolesByProject[proyecto.idProyecto]) {
            rolesByProject[proyecto.idProyecto] = [];
          }
          rolesByProject[proyecto.idProyecto].push(rol);

          if (rol.sortOrder && rol.sortOrder > 0) {
            highlightRoles.push(rol);
          }
        }

        for (const idProyecto of Object.keys(rolesByProject)) {
          const roles = rolesByProject[idProyecto];
          const proyecto = roles[0].personaje.proyecto;
          publishedProjects.push({ proyecto, roles });
        }

        highlightRoles.sort((a, b) => {
          const sa = Number(a.sortOrder);
          const sb = Number(b.sortOrder);
          if (Number.isFinite(sa) && Number.isFinite(sb)) return sa - sb;
          return 0;
        });

        // Aplicar orden de obras guardado en localStorage por el administrador
        try {
          const actorSlug = actor.slug;
          const stored = localStorage.getItem(`actorObrasOrder_${actorSlug}`);
          if (stored) {
            const order = JSON.parse(stored);
            publishedProjects.sort((a, b) => {
              const ia = order.indexOf(a.proyecto.idProyecto);
              const ib = order.indexOf(b.proyecto.idProyecto);
              return (ia >= 0 ? ia : 999) - (ib >= 0 ? ib : 999);
            });
          }
        } catch {}

        this.setState({ actor, highlightRoles, publishedProjects, loading: false });
      })
      .catch((error) => {
        console.error("Error al obtener actor:", error);
        toast.show({
          message: "Ha ocurrido un error al cargar el actor",
          type: "danger",
          position: "bottom-center",
          size: "wide",
          animation: "slide",
          timeout: 5000,
        });
        this.setState({ loading: false });
      });
  };

  resolveImage(base64) {
    if (!base64) return null;
    const s = String(base64);
    if (s.startsWith("data:")) return s;
    if (s.includes("base64,")) return s;
    if (s.startsWith("http://") || s.startsWith("https://")) return s;
    return `data:image/jpeg;base64,${s}`;
  }

  getRoleImage(role) {
    const { actor } = this.state;
    // Prioridad: imageUuid del rol > imageUuid personaje > imageUuid actor
    if (role?.imageUuid) return mfmFramedUrl(role.imageUuid, 270, 360, PORTRAIT_FORMAT_KEY);
    if (role?.personaje?.imageUuid) return mfmFramedUrl(role.personaje.imageUuid, 270, 360, PORTRAIT_FORMAT_KEY);
    if (actor?.imageUuid) return mfmFramedUrl(actor.imageUuid, 270, 360, PORTRAIT_FORMAT_KEY);
    return profile_default_img;
  }

  getProyectoImage(proyecto) {
    if (proyecto?.imageUuid) return mfmFramedUrl(proyecto.imageUuid, 600, 338, LANDSCAPE_FORMAT_KEY);
    return this.resolveImage(proyecto?.imageBase64) || profile_default_img;
  }

  getActorImage() {
    const { actor } = this.state;
    if (actor.imageUuid) return mfmFramedUrl(actor.imageUuid, 270, 360, PORTRAIT_FORMAT_KEY);
    return profile_default_img;
  }

  getRoleImageUuid(role) {
    const { actor } = this.state;
    if (role?.imageUuid) return role.imageUuid;
    if (role?.personaje?.imageUuid) return role.personaje.imageUuid;
    if (actor?.imageUuid) return actor.imageUuid;
    return null;
  }

  openProject = (slug) => {
    window.open(`/project/${slug}`, "_blank");
  };

  openRoleModal = (role) => {
    this.setState({ selectedRole: role, showRoleModal: true });
  };

  closeRoleModal = () => {
    this.setState({ selectedRole: null, showRoleModal: false });
  };

  goBack = () => {
    if (this.props.onBack) {
      this.props.onBack();
    } else {
      window.history.back();
    }
  };

  render() {
    const { actor, highlightRoles, publishedProjects, loading, selectedRole, showRoleModal } =
      this.state;

    if (loading) return (
      <div className="acd-loading">
        <span className="acd-loading-spinner" />
      </div>
    );

    // Edad
    let age;
    if (actor.dateOfBirth) {
      const bd = new Date(actor.dateOfBirth);
      if (!isNaN(bd)) {
        const today = new Date();
        let y = today.getFullYear() - bd.getFullYear();
        const m = today.getMonth() - bd.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < bd.getDate())) y--;
        age = y;
      }
    }

    return (
      <div className="actor-detail">
        {/* Volver */}
        <button className="back-link" onClick={this.goBack}>
          ← Volver
        </button>

        {/* ═══ Nombre — título de página ═══ */}
        <h2 className="acd-name">{actor.name}</h2>
        {actor.actorRole && (
          <p className="acd-role">{actor.actorRole}</p>
        )}

        {/* Meta datos bajo el nombre */}
        <div className="acd-meta">
          {actor.nationality && (
            <span className="acd-meta-item">
              <MDBIcon fas icon="globe-europe" className="me-1" />
              {actor.nationality}
            </span>
          )}
          {actor.dateOfBirth && actor.showSensitive && (
            <span className="acd-meta-item">
              <MDBIcon fas icon="birthday-cake" className="me-1" />
              {actor.dateOfBirth}
              {age != null && ` (${age} años)`}
            </span>
          )}
          {actor.website && (
            <a
              className="acd-meta-item acd-meta-link"
              href={actor.website}
              target="_blank"
              rel="noopener noreferrer"
            >
              <MDBIcon fas icon="link" className="me-1" />
              {actor.website}
            </a>
          )}
          {actor.showSensitive && actor.address && (
            <span className="acd-meta-item">
              <MDBIcon fas icon="map-marker-alt" className="me-1" />
              {actor.address}
            </span>
          )}
          {actor.showSensitive && actor.phone && (
            <span className="acd-meta-item">
              <MDBIcon fas icon="phone" className="me-1" />
              {actor.phone}
            </span>
          )}
          {actor.showSensitive && actor.email && (
            <span className="acd-meta-item">
              <MDBIcon fas icon="envelope" className="me-1" />
              {actor.email}
            </span>
          )}
        </div>

        {/* ═══ Imagen + Biografía (float) ═══ */}
        <div className="acd-bio-block">
          <img
            className="acd-bio-img"
            src={this.getActorImage()}
            alt={actor.name || "Miembro"}
            draggable={false}
          />
          {actor.bio ? (
            <div
              className="acd-bio-text"
              dangerouslySetInnerHTML={{ __html: actor.bio }}
            />
          ) : (
            <p className="acd-bio-text acd-bio-empty">Sin biografía.</p>
          )}
        </div>

        {/* ═══ Obras y personajes ═══ */}
        {publishedProjects.length > 0 && (
          <div className="acd-section">
            <h3 className="section-subtitle">Obras</h3>
            <div className="acd-projects-grid">
              {publishedProjects.map(({ proyecto, roles }) => {
                const projImg = this.getProyectoImage(proyecto);
                return (
                  <div key={proyecto.idProyecto} className="acd-project-card" onClick={() => this.openProject(proyecto.slug)}>
                    <div className="acd-project-card-cover">
                      <img
                        src={projImg}
                        alt={proyecto.title}
                        className="acd-project-card-img"
                        draggable={false}
                      />
                    </div>
                    <div className="acd-project-card-body">
                      <h4 className="acd-project-card-title">{proyecto.title}</h4>
                      <ul className="acd-project-roles-list">
                        {roles.map((role) => {
                          const charName = role.personaje?.name || "Maestro";
                          return (
                            <li key={role.idRol} className="acd-project-role-item">
                              <img
                                src={this.getRoleImage(role)}
                                alt={charName}
                                className="acd-project-role-thumb"
                              />
                              <span>{charName}</span>
                            </li>
                          );
                        })}
                      </ul>
                      <button
                        className="acd-project-link"
                        onClick={(e) => { e.stopPropagation(); this.openProject(proyecto.slug); }}
                      >
                        Ir a obra <MDBIcon fas icon="external-link-alt" size="sm" className="ms-1" />
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* ═══ Roles destacados ═══ */}
        {highlightRoles.length > 0 && (
          <div className="acd-section">
            <h3 className="section-subtitle">Roles destacados</h3>
            <div className="acd-roles-grid">
              {highlightRoles.map((rol, idx) => {
                const charName = rol.personaje?.name || "Maestro";
                const imgUuid = this.getRoleImageUuid(rol);
                return (
                  <div
                    key={rol.idRol || idx}
                    className="acd-role-card"
                    onClick={() => this.openRoleModal(rol)}
                  >
                    <div className="acd-role-card-img-wrapper">
                      <MfmPhoto
                        uuid={imgUuid}
                        formatKey={PORTRAIT_FORMAT_KEY}
                        width={78}
                        height={104}
                        fallback={profile_default_img}
                        alt={charName}
                        className="acd-role-card-img"
                      />
                    </div>
                    <div className="acd-role-card-body">
                      <span className="acd-role-card-name">{charName}</span>
                      {rol.personaje?.proyecto?.title && (
                        <span className="acd-role-card-project">
                          {rol.personaje.proyecto.title}
                        </span>
                      )}
                      <span className="acd-role-card-link">
                        Ver detalle <MDBIcon fas icon="chevron-right" size="sm" />
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* ═══ Modal detalle de rol ═══ */}
        {showRoleModal && selectedRole && (
          <ModalPortal>
            <div className="acd-modal-overlay" onClick={this.closeRoleModal}>
              <div className="acd-modal-card" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="acd-modal-header">
                  <h4 className="acd-modal-title">
                    {selectedRole.personaje?.name || "Maestro"}
                  </h4>
                  <button className="acd-modal-close" onClick={this.closeRoleModal}>
                    <MDBIcon fas icon="times" />
                  </button>
                </div>

                {/* Body — flex 2-column layout */}
                <div className="acd-modal-body">
                  <div className="acd-modal-left">
                    {selectedRole.personaje?.description ? (
                      <div
                        className="acd-modal-rich-text"
                        dangerouslySetInnerHTML={{ __html: selectedRole.personaje.description }}
                      />
                    ) : (
                      <p className="acd-modal-rich-text" style={{ opacity: 0.55, fontStyle: "italic" }}>
                        Sin descripción.
                      </p>
                    )}

                    {selectedRole.notes && (
                      <div className="acd-modal-notes">
                        <p className="acd-modal-label">Notas del rol</p>
                        <p className="acd-modal-value">{selectedRole.notes}</p>
                      </div>
                    )}
                  </div>
                  <div className="acd-modal-right">
                    <img
                      src={this.getRoleImage(selectedRole)}
                      alt={selectedRole.personaje?.name || "Maestro"}
                      className="acd-modal-role-img"
                      draggable={false}
                    />
                  </div>
                </div>

                {/* Obra asociada */}
                {selectedRole.personaje?.proyecto && (
                  <div className="acd-modal-project">
                    <img
                      src={this.getProyectoImage(selectedRole.personaje.proyecto)}
                      alt={selectedRole.personaje.proyecto.title}
                      className="acd-modal-project-img"
                      draggable={false}
                    />
                    <div className="acd-modal-project-info">
                      <span className="acd-modal-project-title">
                        {selectedRole.personaje.proyecto.title}
                      </span>
                      <button
                        className="acd-project-link"
                        onClick={() =>
                          this.openProject(selectedRole.personaje.proyecto.slug)
                        }
                      >
                        Ir a obra <MDBIcon fas icon="external-link-alt" size="sm" className="ms-1" />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </ModalPortal>
        )}
      </div>
    );
  }
}

export default ActorDetail;
